import NumberInput from "../shared/NumberInput";
import StepNavigation from "../shared/StepNavigation";
import { ROIFormData } from "./ROISimulator";
import clsx from "clsx";
import { Battery, BatteryCharging } from "lucide-react";

interface Props {
  data: ROIFormData;
  onChange: (data: Partial<ROIFormData>) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function Step3Speicher({ data, onChange, onNext, onBack }: Props) {
  return (
    <div className="animate-slide-up" data-testid="step-3-speicher">
      {/* Speicher Ja/Nein */}
      <div className="mb-4">
        <p className="text-sm font-medium text-neko-gray-light mb-2">Batteriespeicher gewünscht?</p>
        <div className="grid grid-cols-2 gap-2">
          {[
            { label: "Ohne Speicher", value: false, icon: <Battery className="w-5 h-5" />, hint: "~30% Eigenverbrauch" },
            { label: "Mit Speicher", value: true, icon: <BatteryCharging className="w-5 h-5" />, hint: "~60–70% Eigenverbrauch" },
          ].map(({ label, value, icon, hint }) => (
            <button
              key={String(value)}
              type="button"
              onClick={() => onChange({ mit_speicher: value })}
              className={clsx(
                "flex flex-col items-center gap-2 p-4 rounded-xl border transition-all text-center",
                data.mit_speicher === value
                  ? "border-neko-orange bg-neko-orange/10"
                  : "border-neko-dark-3 bg-neko-dark-2 hover:border-neko-gray"
              )}
              data-testid={`speicher-${String(value)}`}
            >
              <span className={data.mit_speicher === value ? "text-neko-orange" : "text-neko-gray"}>{icon}</span>
              <span className="text-sm font-medium text-neko-white">{label}</span>
              <span className="text-xs text-neko-gray">{hint}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Speichergröße */}
      {data.mit_speicher && (
        <NumberInput
          label="Speichergröße"
          placeholder="10"
          unit="kWh"
          min={3}
          max={30}
          value={data.speicher_kwh ?? ""}
          onChange={(e) => onChange({ speicher_kwh: parseFloat(e.target.value) || undefined })}
          hint="Empfehlung: 1 kWh Speicher pro 1.000 kWh Jahresverbrauch. Typical: 5–15 kWh."
          data-testid="speicher-kwh-input"
        />
      )}

      {/* Einspeisevergütung */}
      <NumberInput
        label="Einspeisevergütung"
        placeholder="8.1"
        unit="ct/kWh"
        min={0}
        max={20}
        value={data.einspeiseverguetung_ct ?? ""}
        onChange={(e) => onChange({ einspeiseverguetung_ct: parseFloat(e.target.value) || 8.1 })}
        hint="Aktuell: 8,1 ct/kWh für Anlagen bis 10 kWp (EEG 2024, fest für 20 Jahre)."
        data-testid="einspeiseverguetung-input"
      />

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextLabel="Rendite berechnen"
        isLastStep
      />
    </div>
  );
}
